import React from 'react';
import { Provider } from 'react-redux';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import Store from './store';

import logo from './assets/logo.png';
import './css/lum-dashboard.scss';
import { AppContent, AppFooter } from './components';

import 'typeface-montserrat';

const StoreInstance = Store();

const theme = createMuiTheme({
    palette: {
        background: {
            paper: 'rgba(48, 54, 64, 0.8)',
            default: '#262930',
        },
    },
    typography: {
        fontFamily: 'Montserrat,Roboto,"Helvetica Neue",Arial,sans-serif',
    },
});

const App = () => {
    return (
        <Provider store={StoreInstance}>
            <MuiThemeProvider theme={theme}>
                <div className="lum-dashboard">
                    <AppContent />
                </div>

                <img alt="logo" className="logo" src={logo} />

                <AppFooter />
            </MuiThemeProvider>
        </Provider>
    );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js